export default "__VITE_ASSET__63ebafba__"